/* global axios */
import ApiClient from './ApiClient';

class AssignableAgents extends ApiClient {
  constructor() {
    super('assignable_agents', { accountScoped: true });
  }

  get(inboxIds) {
    return axios.get(this.url, {
      params: { inbox_ids: inboxIds },
    });
  }

  getPage(inboxIds, page = 1, per_page = 10, query = null) {
    return axios.get(this.url, {
      params: { inbox_ids: inboxIds, page, per_page, query },
    });
  }
}

export default new AssignableAgents();
